import { apiFetch } from "../utils/apiFetch";
import { clearDisplayUser } from "../utils/authStorage";
import React, { useCallback, useEffect, useState } from "react";
import ChatSpace from "./ChatSpace";
import { BsThreeDotsVertical } from "react-icons/bs";
import { useNavigate, useParams } from "react-router";
import { IoCheckmark, IoCheckmarkDone } from "react-icons/io5";
import { useAuth } from "../context/AuthContext";
import { io } from "socket.io-client";
import {
  IoMdArrowDropdown,
  IoMdArrowDropright,
  IoMdTime,
} from "react-icons/io";
import SendInvite from "./SendInvite";
import { CiCirclePlus } from "react-icons/ci";
import ChatListShimmer from "./ChatListShimmer";
import NewChatPopup from "./NewChatPopup";
import { FiEdit } from "react-icons/fi";
import { TiArrowSortedDown } from "react-icons/ti";
import WorkspaceMembers from "./WorkspaceMembers";
import UserRemoved from "./UserRemoved";
import { useSocket } from "../context/SocketContext";
import { useQueryClient } from "@tanstack/react-query";
import useChatCache from "../utils/useChatCache";
import { useCourse } from "../context/CourseContext";

const Chat = () => {
  const client = useQueryClient();
  const [activeChat, setActiveChat] = useState(null);
  const [isNewChat, setIsNewChat] = useState(false);
  const [search, setSearch] = useState("");
  const [people, setPeople] = useState(null);
  const [conversationError, setConversationError] = useState("");
  const { course: workspace, setCourse: setWorkspace } = useCourse();
  const [logoutToggle, setLogoutToggle] = useState(false);
  const [scrollToBottom, setScrollToBottom] = useState(false);
  // const [socket, setSocket] = useState(null);
  // const [isSocketReady, setIsSocketReady] = useState(false);
  const { socket, emitWithAck, isSocketReady } = useSocket();
  const navigate = useNavigate();
  const { userId, setUserId, setUserInfo } = useAuth();
  const effectiveUserId = userId;
  const [groupSettings, setGroupSettings] = useState(false);
  const { slug } = useParams();
  const chatsKey = ["account", userId, "dm-list", slug];
  const [chats, updateChats] = useChatCache(chatsKey);
  const setChats = useCallback(value => updateChats(previous => {
    const next = typeof value === "function" ? value(previous) : value;
    return Array.isArray(next) ? next.filter(row => row.friend) : next;
  }), [updateChats]);
  const [listOfMessagesAndInfo, setListOfMessagesAndInfo] = useChatCache(["account", userId, "dm-messages", slug, activeChat?._id || "none"]);
  const [sendInvitePopUp, setSendInvitePopUp] = useState(false);
  const [newChatPopup, setNewChatPopup] = useState(false);
  const [isChannelsOpen, setIsChannelsOpen] = useState(true);
  const [isDmsOpen, setIsDmsOpen] = useState(true);
  const [workspaceMembersPopUp, setWorkspaceMembersPopUp] = useState(false);
  const [members, setMembers] = useState(null);
  const { userInfo } = useAuth();
  const [statusChange, setStatusChange] = useState(null);
  const [memberRemovePopup, setMemberRemovePopup] = useState(null);
  const [userGotRemovedPopUp, setUserGotRemovedPopUp] = useState(false);

  // const emitWithAck = useCallback(
  //   (event, payload = {}) =>
  //     new Promise((resolve, reject) => {
  //       if (!socket || !socket.connected) {
  //         reject(new Error("Socket not connected"));
  //         return;
  //       }

  //       socket.emit(event, payload, (response) => {
  //         if (!response?.ok) {
  //           reject(new Error(response?.error || "Socket request failed"));
  //           return;
  //         }
  //         resolve(response.data);
  //       });
  //     }),
  //   [socket],
  // );

  const filteredFriends = chats
    ? chats.filter((friend) => {
        const fr = friend?.friend?.username || "";
        return fr.toLowerCase().includes(search.toLowerCase().trim());
      })
    : [];

  const filteredPeople = people
    ? people.filter((person) => {
        return person.username
          .toLowerCase()
          .includes(search.toLowerCase().trim());
      })
    : people;

  // useEffect(() => {
  //   if (!localStorage.getItem("token")) {
  //     navigate("/");
  //     return;
  //   }

  //   const sock = io(`${process.env.API_URL}`, {
  //     auth: { token: localStorage.getItem("token"), slug },
  //   });

  //   const onConnect = () => setIsSocketReady(true);
  //   const onDisconnect = () => setIsSocketReady(false);
  //   const onConnectError = (err) => {
  //     setIsSocketReady(false);
  //     const msg = String(err?.message || "Socket connection failed");
  //     if (msg.toLowerCase().includes("invalid token")) {
  //       localStorage.clear();
  //       setUserId(null);
  //       navigate("/");
  //     }
  //     if (msg.toLowerCase().includes("access denied")) {
  //       alert(msg);
  //       navigate("/workspaces");
  //     }

  //     console.error("socket connect_error:", msg);
  //   };

  //   sock.on("connect", onConnect);
  //   sock.on("disconnect", onDisconnect);
  //   sock.on("connect_error", onConnectError);
  //   setSocket(sock);

  //   return () => {
  //     sock.off("connect", onConnect);
  //     sock.off("disconnect", onDisconnect);
  //     sock.off("connect_error", onConnectError);
  //     sock.disconnect();
  //     setIsSocketReady(false);
  //     setSocket(null);
  //   };
  // }, [navigate, setUserId]);

  useEffect(() => {
    if (!socket || !isSocketReady) return;

    const fetchData = async () => {
      try {
        const friends = await client.fetchQuery({ queryKey: ["account", userId, "dm-list", slug], queryFn: async () => {
          const data = await emitWithAck("friends:list");
          return (data.friends || []).filter(row => row.friend);
        } });

        friends.forEach(async (friendInfo) => {
          if (!friendInfo?.lastMessage?._id) return;
          // if (!friendInfo.lastMessage.sender) return;
          if (friendInfo?.lastMessage?.sender?._id === userId) return;

          const myStatus = friendInfo.lastMessage.receiversStatus?.find(
            (recInfo) => recInfo.receiverId === userId,
          );
          if (!myStatus || myStatus.status === "read" || myStatus.status === "delivered")
            return;
          try {
            await emitWithAck("message:delivered", {
              messageId: friendInfo.lastMessage._id,
            });
          } catch (err) {
            alert(err.message);
          }
        });
      } catch (err) {
        alert(err.message);
      }
    };

    fetchData();
  }, [socket, isSocketReady, emitWithAck, slug, userId, client]);


  const fetchPeople = async () => {
    setPeople(null);
    setConversationError("");
    try {
      const data = await emitWithAck("users:list");
      setPeople(Array.isArray(data.users) ? data.users : []);
    } catch (error) {
      setConversationError(error.message || "Could not load members");
    }
  };

  const logout = async () => {
    try {
      // await emitWithAck("auth:logout");

      const res = await apiFetch(`${process.env.API_URL}/api/auth/logout`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",

        },
      });

      if (!res.ok) {
        const errorText = await res.text();
        throw new Error(errorText + `: ${res.status}`);
      }

      socket?.disconnect();
      clearDisplayUser();
      setUserId(null);
      setUserInfo(null);
      navigate("/");
    } catch (err) {
      alert(err.message);
    }
  };

  console.log("friends", filteredFriends);

  return (
    <>
      <div
        className="mx-auto my-6 flex h-[calc(100dvh-170px)] min-h-[420px] max-h-[820px] w-[calc(100%-2rem)] max-w-6xl overflow-hidden rounded-lg border border-gray-200 bg-white"
        onClick={() => {
          setLogoutToggle(false);
          setGroupSettings(false);
        }}
      >
        <div
          className={`${activeChat ? "hidden md:flex" : "flex"} chat-sidebar w-full md:w-64 md:shrink-0 border-r border-gray-200 h-full min-h-0 bg-white flex-col`}
        >
          <div className="px-3 pt-3">
            <button type="button" onClick={() => { setNewChatPopup(true); fetchPeople(); }} className="flex min-h-10 w-full items-center justify-center gap-2 rounded-md bg-orange-700 px-3 text-sm font-semibold text-white hover:bg-orange-800">
              <FiEdit aria-hidden="true" />New conversation
            </button>
          </div>

          <div className="p-3">
            <div className="relative">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-search absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400"
                data-fg-dqpt23="1.18:77.4089:/src/app/components/Sidebar.tsx:108:11:3503:85:e:Search::::::B9rK"
                data-fgid-dqpt23=":r6l:"
              >
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.3-4.3"></path>
              </svg>
              <input
                aria-label="Search conversations"
                className="h-10 w-full min-w-0 rounded-md border border-gray-300 bg-white py-2 pl-9 pr-3 text-sm text-gray-900 outline-none focus:border-orange-600"
                placeholder="Search..."
                type="search"
                value={search}
                onChange={(e) => {
                  setIsChannelsOpen(true);
                  setIsDmsOpen(true);
                  setSearch(e.target.value);
                }}
              />
            </div>
          </div>

          <div className="box-border flex-1 min-h-0 overflow-y-auto text-gray-900 m-2 rounded-lg">
            {!chats ? (
              <ChatListShimmer />
            ) : (
              <>
                {/* {search.trim().length > 0 && filteredFriends.length > 0 ? (
                  <div className="font-bold">Chats</div>
                ) : (
                  ""
                )} */}
                {/* <div className=""> */}
                <div className="px-2 py-2">
                  <div className="space-y-1 rounded-lg bg-white">
                    {isDmsOpen &&
                      filteredFriends
                        .filter((friend) => friend?.friend)
                        .map((friend) => (
                          <div
                            role="button" tabIndex={0}
                            onKeyDown={event => { if (event.key === "Enter" || event.key === " ") { event.preventDefault(); event.currentTarget.click(); } }}
                            className={`flex cursor-pointer items-center justify-between px-2 py-3 rounded-md transition-colors ${activeChat?._id === friend.friend._id ? "bg-orange-50 text-orange-800" : "text-gray-900 hover:bg-gray-100"}`}
                            key={friend?.friend?._id}
                            onClick={() => {
                              setActiveChat((prev) => {
                                const targetId =
                                  friend?.friend?._id || friend?.group?._id;
                                if (prev?._id === targetId) return prev;
                                return {
                                  _id:
                                    friend?.friend?._id || friend?.group?._id,
                                  username:
                                    friend?.friend?.username ||
                                    friend?.group?.name,
                                  email:
                                    friend?.friend?.email ||
                                    friend?.group?.participants
                                      .map(
                                        (participant) => participant.username,
                                      )
                                      .sort()
                                      .join(","),
                                  participants:
                                    friend?.friend?.email ||
                                    friend?.group?.participants,
                                  participantIds:
                                    friend?.friend?._id ||
                                    friend?.group?.participants.map(
                                      (participant) => participant._id,
                                    ),
                                  type: friend?.friend ? "direct" : "group",
                                  admin:
                                    friend?.friend?.admin ||
                                    friend?.group?.admin,
                                  allParticipants:
                                    friend?.group?.allParticipants,
                                };
                              });
                              setChats((prev) => {
                                if (!Array.isArray(prev)) return prev;
                                const selectedId = String(
                                  friend?.friend?._id || friend?.group?._id,
                                );
                                return prev.map((row) =>
                                  String(
                                    row?.friend?._id || row?.group?._id,
                                  ) === selectedId
                                    ? { ...row, unreadCount: 0 }
                                    : row,
                                );
                              });
                            }}
                          >
                            <div className="flex items-center gap-2 flex-1 min-w-0">
                              <div className="relative">
                                <span className="relative flex size-10 shrink-0 overflow-hidden rounded-full h-6 w-6">
                                  <img
                                    className="aspect-square size-full"
                                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQhxtx5uOH2FwWtC_-HAnN75PQqBFgfLF9D2w&s"
                                  ></img>
                                </span>
                              </div>
                              <span className="text-sm truncate flex-1">
                                {friend?.friend?.username}
                              </span>
                            </div>
                            {Number(friend.unreadCount || 0) > 0 ? (
                              <span className="inline-flex items-center justify-center rounded-md border py-0.5 font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden border-transparent [a&]:hover:bg-secondary/90 bg-red-600 text-white text-xs h-5 px-1.5">
                                {friend.unreadCount}
                              </span>
                            ) : null}
                            {/* <div>
                               <h1>{friend?.friend?.username}</h1>
                              <div className="flex gap-2 items-center">
                                 <div>
                                {(friend.lastMessage?.sender?._id ||
                                  friend.lastMessage?.sender) ===
                                effectiveUserId ? (
                                  friend.lastMessage.deleteStatus ===
                                  "alive" ? (
                                    friend.lastMessage?.status === "sent" ? (
                                      <IoCheckmark />
                                    ) : friend.lastMessage?.status ===
                                      "delivered" ? (
                                      <IoCheckmarkDone />
                                    ) : friend.lastMessage?.status ===
                                      "read" ? (
                                      <IoCheckmarkDone className="text-blue-400" />
                                    ) : (
                                      <IoMdTime />
                                    )
                                  ) : null
                                ) : friend.type === "group" &&
                                  friend.lastMessage.sender ? (
                                  friend.lastMessage.sender?.username + ":"
                                ) : null}
                              </div>
                              <div>
                                {friend.lastMessage?.messageType === "image"
                                  ? "Image"
                                  : (() => {
                                      const preview =
                                        friend.lastMessage.deleteStatus ===
                                        "alive"
                                          ? String(
                                              friend.lastMessage
                                                ?.contentPreview || "",
                                            )
                                          : "This message was deleted";
                                      return (
                                        preview.substring(0, 30) +
                                        (preview.length > 30 ? "..." : "")
                                      );
                                    })()}
                              </div>
                                {Number(friend.unreadCount || 0) > 0 ? (
                                  <div className="ml-2 min-w-5 h-5 px-1 rounded-full bg-orange-500 text-white text-xs flex items-center justify-center">
                                    {friend.unreadCount}
                                  </div>
                                ) : null}
                              </div>
                            </div> */}
                          </div>
                        ))}
                  </div>
                </div>
                {/* </div> */}
              </>
            )}
          </div>
        </div>
        <ChatSpace
          socket={socket}
          emitWithAck={emitWithAck}
          activeChat={activeChat}
          userId={effectiveUserId}
          setChats={setChats}
          listOfMessagesAndInfo={listOfMessagesAndInfo}
          setListOfMessagesAndInfo={setListOfMessagesAndInfo}
          scrollToBottom={scrollToBottom}
          setScrollToBottom={setScrollToBottom}
          fetchPeople={fetchPeople}
          people={people}
          setPeople={setPeople}
          setActiveChat={setActiveChat}
          groupSettings={groupSettings}
          setGroupSettings={setGroupSettings}
          workspace={workspace}
          members={members}
          setMembers={setMembers} //workspace members
          setUserGotRemovedPopUp={setUserGotRemovedPopUp}
          setWorkspace={setWorkspace}
        />
      </div>
      {sendInvitePopUp && (
        <SendInvite
          workspace={workspace}
          setSendInvitePopUp={setSendInvitePopUp}
        />
      )}
      {newChatPopup && (
        <NewChatPopup
          error={conversationError}
          onRetry={fetchPeople}
          setNewChatPopup={setNewChatPopup}
          people={people}
          setActiveChat={setActiveChat}
        />
      )}
      {workspaceMembersPopUp && (
        <WorkspaceMembers
          workspace={workspace}
          members={members}
          setMembers={setMembers}
          userId={userId}
          userInfo={userInfo}
          statusChange={statusChange}
          setStatusChange={setStatusChange}
          memberRemovePopup={memberRemovePopup}
          setMemberRemovePopup={setMemberRemovePopup}
          setWorkspaceMembersPopUp={setWorkspaceMembersPopUp}
        />
      )}
      {userGotRemovedPopUp && (
        <UserRemoved setUserGotRemovedPopUp={setUserGotRemovedPopUp} />
      )}
    </>
  );
};

export default Chat;
